import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { Slider } from "@mui/material";
import getSymbolFromCurrency from "currency-symbol-map";
import { main_server } from "../../constants";

function PlanModal(props) {
  const [selected, setSelected] = useState(0);
  const [currencySign, setCurrencySign] = useState("$");
  const basicRef = React.createRef();
  const proRef = React.createRef();
  const entRef = React.createRef();

  useEffect(() => {
    setCurrencySign(getSymbolFromCurrency(props.currency));
  }, [props.currency]);

  const marks = [
    {
      value: 0,
      label: "",
    },
    {
      value: 20,
      label: "20",
    },
    {
      value: 50,
      label: "50",
    },
    {
      value: 100,
      label: "100",
    }
  ];

  function valueLabelFormat(value) {
    if (value == 0) {
      props.setRequests(10);
    } else {
      props.setRequests(value);
    }
    return `${value == 0 ? "0" : value + 'K'}`;
  }
  /*
  useEffect(() => {
    if (props.plan == 0) {props.setSelected(0)} else {props.setSelected(props.plan - 1)}
  }, [props.plan]);
*/
  useEffect(() => {
    var ref = basicRef;
    if (props.selected == 1) {
      ref = proRef;
    } else if (props.selected == 2) {
      ref = entRef;
    }
    props.setAmount(parseFloat(ref.current.innerHTML));
  }, [basicRef, proRef, entRef, props.selected]);

  return (
    <section className={styles["pricing"]}>
      <header className={styles["pricing__header"]}>
        <h1 className={`mb-[10px] ${styles["pricing__title"]}`}>Pricing plans</h1>
        <div className={styles["plan-duration"]}>
          <div className={styles["plan-duration--active"]}>Monthly</div>
          <div
            className={styles["plan-duration__toggle"]}
            style={
              props.yearly
                ? { background: "linear-gradient(130deg, white, #4e93f1)" }
                : {
                    background: "linear-gradient(130deg, var(--pink), #4e93f1)",
                  }
            }
            onClick={() => {
              props.setYearly(!props.yearly);
            }}
          >
            <div
              className={styles["plan-duration__toggle-ball"]}
              style={props.yearly ? { position: "relative", left: "20px" } : {}}
            ></div>
          </div>
          <div className={styles["plan-duration__text"]}>Yearly</div>
        </div>
        {/*<Slider
          defaultValue={0}
          valueLabelFormat={valueLabelFormat}
          getAriaValueText={() => {}}
          valueLabelDisplay="auto"
          step={null}
          marks={marks}
          style={{ width: "60%", marginBottom: "20px" }}
          min={0}
          max={100}
        />*/}
      </header>
      <article className={styles["plans"]}>
        <div className={styles["plans__list"]}>
          <article
            className={
              styles[props.selected == 0 ? "plan__item--active" : "plan__item"]
            }
            style={{
              borderRadius: "10px",
              display: "flex",
              width: "230px",
              height: "400px",
              flexDirection: "column",
              justifyContent: "space-between",
              margin: "1rem",
            }}
            onClick={() => {
              props.setSelected(0);
              props.setAmount(parseFloat(basicRef.current.innerHTML));
            }}
          >
            <div className={styles["plan__header"]}>
              <h2 className={styles["plan__title"]}>Basic</h2>
              <h1
                className={styles["plan__price"]}
                ref={basicRef}
                sign={currencySign}
                style={{ paddingTop: "50px", fontWeight: "600" }}
              >
                {(
                  (props.yearly ? 6 : 7) *
                  props.exchange
                ).toFixed(2)}
              </h1>
            </div>

            <ul
              className={styles["plan__feature-list"]}
              style={{ marginBottom: "68px" }}
            >
              <li></li>
              <li></li>
              <li></li>
              <li className={styles["plan__feature-item"]}>
                <span className={styles["accent-2"]}>10 MN/s</span> Stockfish Analysis
              </li>
              <li className={styles["plan__feature-item"]}>
                <span className={styles["accent-2"]}>50MB</span> Cloud Storage
              </li>
              <li className={styles["plan__feature-item"]}>
                Explore 5.4 Million Master Games
              </li>
              <li className={styles["plan__feature-item"]}>
                Unlimited Evaluation Database Access
              </li>

            </ul>
          </article>
          <article
            className={
              styles[props.selected == 1 ? "plan__item--active" : "plan__item"]
            }
            style={{
              borderRadius: "10px",
              display: "flex",
              height: "400px",
              width: "230px",
              flexDirection: "column",
              justifyContent: "space-between",
              margin: "1rem",
            }}
            onClick={() => {
              props.setSelected(1);
              props.setAmount(parseFloat(proRef.current.innerHTML));
            }}
          >
            <div className={styles["plan__header"]}>
              <h2 className={styles["plan__title"]}>Professional</h2>
              <h1
                className={styles["plan__price"]}
                ref={proRef}
                sign={currencySign}
                style={{ paddingTop: "50px", fontWeight: "600" }}
              >
                {(
                  (props.yearly ? 25 : 30) *
                  props.exchange
                ).toFixed(2)}
              </h1>
            </div>
            <ul className={styles["plan__feature-list"]}>
              <li className={styles["plan__feature-item"]}>
                <span className={styles["accent-2"]}>30 MN/s</span> Stockfish Analysis
              </li>
              <li className={styles["plan__feature-item"]}>
                <span className={styles["accent-2"]}>100 MB</span> Cloud Storage
              </li>
              <li className={styles["plan__feature-item"]}>
                Explore 5.4 Million Master Games
              </li>
              <li className={styles["plan__feature-item"]}>
                Unlimited Evaluation Database Access
              </li>
              <li>Unlimited Variations Download</li>
              <li>24/7 Live Support</li>
            </ul>
          </article>
          <article
            className={
              styles[props.selected == 2 ? "plan__item--active" : "plan__item"]
            }
            style={{
              borderRadius: "10px",
              display: "flex",
              height: "400px",
              width: "230px",
              flexDirection: "column",
              justifyContent: "space-between",
              margin: "1rem",
            }}
            onClick={() => {
              props.setSelected(2);
              props.setAmount(parseFloat(entRef.current.innerHTML));
            }}
          >
            <div className={styles["plan__header"]}>
              <h2 className={styles["plan__title"]}>Grandmaster</h2>
              <h1
                className={styles["plan__price"]}
                ref={entRef}
                sign={currencySign}
                style={{ paddingTop: "50px", fontWeight: "600" }}
              >
                {(
                  (!props.yearly ? 120 : 100) *
                  props.exchange
                ).toFixed(2)}
              </h1>
            </div>

            <ul className={styles["plan__feature-list"]}>
              <li className={styles["plan__feature-item"]}>
                <span className={styles["accent-2"]}>100 MN/s</span> Stockfish Analysis
              </li>
              <li className={styles["plan__feature-item"]}>
                <span className={styles["accent-2"]}>Unlimited</span> Cloud Storage
              </li>
              <li className={styles["plan__feature-item"]}>
                Explore 5.4 Million Master Games
              </li>
              <li className={styles["plan__feature-item"]}>
                Unlimited Evaluation Database Access
              </li>
              <li>Unlimited Variations Download</li>
              <li>24/7 Live Support</li>
            </ul>
          </article>
        </div>
      </article>

      <footer>
        <div className={styles["currency"]}>
          <span className={styles["currency__text"]}>Currency</span>
          <select
            className={styles["currency__select"]}
            onChange={(e) => {
              const val = e.target.value;
              var requestURL = main_server + "convert?val=" + val;
              var request = new XMLHttpRequest();
              request.open("GET", requestURL);
              request.setRequestHeader(
                "Authorization",
                "Bearer " + localStorage.getItem("chesscloud-token"),
              );
              request.send();

              request.onload = function () {
                var response = request.response;
                setCurrencySign(getSymbolFromCurrency(val));
                props.setCurrency(val);
                props.setExchange(response);
              };
            }}
          >
            <option
              selected={props.currency === "USD" ? true : false}
              value="USD"
              label="US dollar"
            >
              USD
            </option>
            <option
              selected={props.currency === "EUR" ? true : false}
              value="EUR"
              label="Euro"
            >
              EUR
            </option>
            <option
              selected={props.currency === "JPY" ? true : false}
              value="JPY"
              label="Japanese yen"
            >
              JPY
            </option>
            <option
              selected={props.currency === "GBP" ? true : false}
              value="GBP"
              label="Pound sterling"
            >
              GBP
            </option>
            <option disabled>──────────</option>
            <option
              selected={props.currency === "AUD" ? true : false}
              value="AUD"
              label="Australian dollar"
            >
              AUD
            </option>
            <option
              selected={props.currency === "BRL" ? true : false}
              value="BRL"
              label="Brazilian real"
            >
              BRL
            </option>
            <option
              selected={props.currency === "CAD" ? true : false}
              value="CAD"
              label="Canadian dollar"
            >
              CAD
            </option>
            <option
              selected={props.currency === "CZK" ? true : false}
              value="CZK"
              label="Czech koruna"
            >
              CZK
            </option>
            <option
              selected={props.currency === "DKK" ? true : false}
              value="DKK"
              label="Danish krone"
            >
              DKK
            </option>
            <option
              selected={props.currency === "HKD" ? true : false}
              value="HKD"
              label="Hong Kong dollar"
            >
              HKD
            </option>
            <option
              selected={props.currency === "HUF" ? true : false}
              value="HUF"
              label="Hungarian forint"
            >
              HUF
            </option>
            <option
              selected={props.currency === "ILS" ? true : false}
              value="ILS"
              label="Israeli new shekel"
            >
              ILS
            </option>
            <option
              selected={props.currency === "MXN" ? true : false}
              value="MXN"
              label="Mexican peso"
            >
              MXN
            </option>
            <option
              selected={props.currency === "TWD" ? true : false}
              value="TWD"
              label="New Taiwan dollar"
            >
              TWD
            </option>
            <option
              selected={props.currency === "NZD" ? true : false}
              value="NZD"
              label="New Zealand dollar"
            >
              NZD
            </option>
            <option
              selected={props.currency === "NOK" ? true : false}
              value="NOK"
              label="Norwegian krone"
            >
              NOK
            </option>
            <option
              selected={props.currency === "PHP" ? true : false}
              value="PHP"
              label="Philippine peso"
            >
              PHP
            </option>
            <option
              selected={props.currency === "PLN" ? true : false}
              value="PLN"
              label="Polish złoty"
            >
              PLN
            </option>
            <option
              selected={props.currency === "SGD" ? true : false}
              value="SGD"
              label="Singapore dollar"
            >
              SGD
            </option>
            <option
              selected={props.currency === "SEK" ? true : false}
              value="SEK"
              label="Swedish krona"
            >
              SEK
            </option>
            <option
              selected={props.currency === "CHF" ? true : false}
              value="CHF"
              label="Swiss franc"
            >
              CHF
            </option>
            <option
              selected={props.currency === "THB" ? true : false}
              value="THB"
              label="Thai baht"
            >
              THB
            </option>
          </select>
          
        </div>
      </footer>
    </section>
  );
}

export default PlanModal;
